/**
 * 3B-1: 性別選択サブステップ
 *
 * 3択タイルデザイン（IconMethodStepと同様）
 * コンテンツのみ表示（フッターは親で管理）
 */
import I18n from "common/i18n";
import { CreateUserState, ChildGender } from "../../types";

interface GenderStepProps {
  state: CreateUserState;
  updateState: (updates: Partial<CreateUserState>) => void;
}

// 性別選択肢（3択）- タイルデザイン用
const GENDER_OPTIONS: {
  key: ChildGender;
  labelKey: string;
  icon: string;
  bgColor: string;
  textColor: string;
}[] = [
  {
    key: ChildGender.MALE,
    labelKey: "MSG_GENDER_MALE",
    icon: "man",
    bgColor: "bg-blue-100",
    textColor: "text-blue-100",
  },
  {
    key: ChildGender.FEMALE,
    labelKey: "MSG_GENDER_FEMALE",
    icon: "woman",
    bgColor: "bg-red-100",
    textColor: "text-red-100",
  },
];

export const GenderStep = ({ state, updateState }: GenderStepProps) => {
  const handleSelect = (gender: ChildGender) => {
    updateState({ gender });
  };

  // 選択状態のテキストを取得
  const getStatusText = () => {
    if (!state.gender) {
      return I18n.t("MSG_GENDER_NOT_SELECTED");
    }
    const selected = GENDER_OPTIONS.find((opt) => opt.key === state.gender);
    return selected ? I18n.t(selected.labelKey) : I18n.t("MSG_GENDER_NOT_SELECTED");
  };

  return (
    <div className="flex-col-el items-center justify-center w-full h-full">
      {/* タイトル */}
      <p className="text-body text-[28px] text-textcolor-black !mb-2">
        {I18n.t("MSG_GENDER_SELECT_TITLE")}
      </p>
      {/* 補助テキスト（ラベル：ステータス） */}
      <p className="text-body text-[20px] text-gray-100 !mb-10">
        {I18n.t("MSG_GENDER_STATUS_LABEL")}：{getStatusText()}
      </p>
      {/* 性別選択タイル */}
      <div className="flex-row-el flex-center gap-6">
        {GENDER_OPTIONS.map((option) => {
          const isSelected = state.gender === option.key;
          return (
            <div
              key={option.key}
              onClick={() => handleSelect(option.key)}
              className={`
                flex-col-el items-center justify-center w-[200px] h-[200px] rounded-[8px]
                cursor-pointer select-none relative
                ${isSelected ? option.bgColor : "bg-gray-10"}
              `}
            >
              {/* ラジオボタン風マーカー */}
              <span
                className={`material-symbols-outlined absolute top-3 left-3 !text-2xl ${isSelected ? "text-white" : option.textColor}`}
              >
                {isSelected ? "radio_button_checked" : "radio_button_unchecked"}
              </span>
              <span
                className={`material-symbols-outlined !text-6xl mb-3 ${isSelected ? "text-white" : option.textColor}`}
              >
                {option.icon}
              </span>
              <p
                className={`text-body text-[24px] text-center ${isSelected ? "text-white" : option.textColor}`}
              >
                {I18n.t(option.labelKey)}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
